'use client';

import * as React from 'react';

import { cn } from '../lib/utils';

type FilterChipProps = Omit<React.ComponentProps<'button'>, 'aria-pressed'> & {
  active: boolean;
};

/** Pill toggle for filter rows. forwardRef keeps it composable via `asChild`/`render` triggers. */
const FilterChip = React.forwardRef<HTMLButtonElement, FilterChipProps>(
  ({ active, className, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      aria-pressed={active}
      className={cn(
        'shrink-0 rounded-full border px-3 py-1 text-xs transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[var(--l3-violet)]',
        active
          ? 'border-[var(--l3-violet)] bg-[var(--l3-violet)] text-white'
          : 'border-border hover:border-[var(--l3-violet)] hover:bg-[var(--l3-violet-soft)] hover:text-[var(--l3-violet)]',
        'disabled:cursor-not-allowed disabled:border-dashed disabled:text-muted-foreground disabled:hover:border-border disabled:hover:bg-transparent disabled:hover:text-muted-foreground',
        className,
      )}
      {...props}
    />
  ),
);
FilterChip.displayName = 'FilterChip';

export { FilterChip };
export type { FilterChipProps };
